import { DataType } from '../types';
import slab2reuse from './slab-2-reuse-example.json';

export const ExampleDataType: DataType = slab2reuse as unknown as DataType;
